import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignDresden() {
  return <CityLandingPage city="Dresden" citySlug="dresden" variant="webdesign" />;
}
